// extracted by mini-css-extract-plugin
export default {"sendBtn":"Sms_sendBtn__u4q8L","formCtrl":"Sms_formCtrl__NREE7"};